<script lang="ts">
import {
  NamedThemeColors,
  type TNamedThemeColorValue,
} from '@goodlifeplus/design-system/theme'
import { type PropType, defineComponent } from 'vue'

/**
 * A simple badge.
 */
export default defineComponent({
  props: {
    size: {
      default: 'sm',
      type: String,
    },
    color: {
      type: String as PropType<TNamedThemeColorValue>,
    },
  },
  setup() {
    return {
      NamedThemeColors,
    }
  },
})
</script>

<template>
  <span
    class="badge flex h-fit w-fit items-center justify-center whitespace-nowrap rounded-sm py-1 font-bold leading-none"
    :class="{
      'px-1 text-2xs': size === 'sm',
      'px-3 text-xs': size === 'md',
      'px-2 py-1 text-base': size === 'lg',
      'bg-primary-lighter text-primary': color === NamedThemeColors.Primary,
      'bg-[#EFFDF4] text-[#008236]': color === NamedThemeColors.Secondary,
      'bg-[#FFE3CC] text-[#FF7300]': color === NamedThemeColors.Tertiary,
      'bg-[#E9F5FB] text-[#5F7D92]': color === NamedThemeColors.Neutral,
      'text-black': !color || color === NamedThemeColors.Monochrome,
    }"
  >
    <slot />
  </span>
</template>
